import createBrowserHistory from "history/createBrowserHistory";
import createHashHistory from "history/createHashHistory";

const PREVIEW_PATTERN = /^\/index\.([a-f0-9]{40})\.html/;

export const createHistory = () => {
  const { location: { pathname = "" } = {} } = window;
  const preview = PREVIEW_PATTERN.test(pathname);
  return preview ? createHashHistory() : createBrowserHistory();
};
